module.exports = __webpack_public_path__ + "img/n02.a60856db.png";